<template>
  <div :class="classes" @click="$emit('click')">
    {{ $t('wizard.loadMoreAnswerOptions') }}
  </div>
</template>

<script>
// @flow

export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes (): Object {
      return {
        'trbo-a-load-more-options-button': true,
        'trbo-a-load-more-options-button--is-disabled': this.isDisabled
      }
    }
  }
}
</script>

<style scoped src="./load-more-options-button.scss" />
